import SaccSarr from "../";

const routes = [
    { name: "SaccSarrPage", path: "/saccsarr/test", component: SaccSarr.SaccSarrIntegrazione, meta: { title: "Integrazioni Sarr Sacc" } },
];
export default routes;
